import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import SectionTitle from '../../components/SectionTitle';
import SingleServiceTwo from '../../components/Service/SingleServiceTwo';

import serviceImg1 from '../../assets/img/service/service-2-7.jpg';
import serviceImg2 from '../../assets/img/service/service-2-8.jpg';
import serviceImg3 from '../../assets/img/service/service-2-9.jpg';
import serviceImg4 from '../../assets/img/service/service-2-10.jpg';
import serviceImg5 from '../../assets/img/service/service-2-11.jpg';
import serviceImg6 from '../../assets/img/service/service-2-12.jpg';
import serviceImg7 from '../../assets/img/service/service-2-13.jpg';
import serviceImg8 from '../../assets/img/service/service-2-14.jpg';
import serviceImg9 from '../../assets/img/service/service-2-15.jpg';
import serviceImg10 from '../../assets/img/service/service-2-16.jpg';
import serviceImg11 from '../../assets/img/service/service-2-17.jpg';
import serviceImg12 from '../../assets/img/service/service-2-18.jpg';
import ServicesDefault from '../../pages/home-5/ServiceArea';

const ServiceMain = () => {
  return (
    <main>
      <Breadcrumb title="Services" />

      <div className="it-service-2-area pt-120 pb-90">
        <div className="container">
          <div className="it-service-2-title-wrapper mb-65">
            <div className="row align-items-end">
              <div className="col-12">
                <SectionTitle
                  itemClass="it-service-2-title-box text-center"
                  subTitleClass="it-section-subtitle"
                  subTitle="OUR SERVICES"
                  titleClass="it-section-title"
                  title="Services We Provide."
                />
              </div>
            </div>
          </div>
          {/* <div className="row">
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <SingleServiceTwo
                serviceImage={serviceImg1}
                title="Internal Medicine"
                description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <SingleServiceTwo
                serviceImage={serviceImg2}
                title="Dental Care"
                description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".7s"
            >
              <SingleServiceTwo
                serviceImage={serviceImg3}
                title="Urology Care"
                description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <SingleServiceTwo
                serviceImage={serviceImg4}
                title="Neurology Care"
                description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <SingleServiceTwo
                serviceImage={serviceImg5}
                title="Gynecologists"
                description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".7s"
            >
              <SingleServiceTwo
                serviceImage={serviceImg6}
                title="Ophthalmology"
                description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <SingleServiceTwo
                serviceImage={serviceImg7}
                title="Gynecologists"
                description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <SingleServiceTwo
                serviceImage={serviceImg8}
                title="Cardiology"
                description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".7s"
            >
              <SingleServiceTwo
                serviceImage={serviceImg9}
                title="Surgery Center"
                description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <SingleServiceTwo
                serviceImage={serviceImg10}
                title="Hematology"
                description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <SingleServiceTwo
                serviceImage={serviceImg11}
                title="Pulmonology"
                description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
              />
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".7s"
            >
              <SingleServiceTwo
                serviceImage={serviceImg12}
                title="Audiology Care"
                description="nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia"
              />
            </div>
          </div> */}
          
        </div>
        < ServicesDefault/>
      </div>
    </main>
  );
};

export default ServiceMain;
